import { Table } from "antd";
import React from "react";
import BannerCard from "../../../common/components/BannerCard";
import CleanButton from "../../../common/components/CleanButton";
import { Tooltips } from "../../../common/constants/Tooltips";
import CaseBalanceViolationModal from "./case-balance-violation-modal";
import useCaseBalance from "./useCaseBalance";

const CaseBalanceVoilationTable = ({ ...props }) => {
  const { isModalOpen, setIsModalOpen, handleViolationView, violationDetails, form } = props;
  const { caseMaster } = useCaseBalance();

  const columns = [
    { key: "case", title: "Violation Case", dataIndex: "VIOLATION_CASE" },
    { key: "state", title: "State", dataIndex: "STATE_COSTS" },
    { key: "local", title: "Local", dataIndex: "LOCAL_COSTS" },
    { key: "other", title: "Other", dataIndex: "OTHER_COSTS" },
    { key: "fees", title: "Fees", dataIndex: "FEES" },
    { key: "fines", title: "Fines", dataIndex: "FINE" },
    { key: "balance", title: "Balance", dataIndex: "BALANCE" },
    { key: "restitution", title: "Restitution", dataIndex: "RESTITUTION" },
    { key: "actions", title: "Actions", dataIndex: "VIOLATION_CASE", render: (val) => <CleanButton icon="eye" type="link" tooltip={Tooltips.View} onClick={() => handleViolationView(val)} /> }
  ];

  return (
    <BannerCard title="Balance Violation">
      <Table columns={columns} dataSource={caseMaster?.balances?.LIST} scroll={{ x: 720 }} />
      <CaseBalanceViolationModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} violationDetails={violationDetails} form={form} />
    </BannerCard>
  );
};

export default CaseBalanceVoilationTable;
